import type * as hast from 'hast';

import { expression } from '@gitbook/doc-core';
import type { Inline } from '@gitbook/slate';

import { concatText, getClassNamesAttribute, sanitizeSpaces, trimNewlines } from './utils';

/**
 * Process an element that can be an inline expression.
 */
export function processInlineExpressionElement(node: hast.Element): Inline[] | void {
    if (!isInlineExpression(node)) {
        return;
    }

    // We go into the children and extract the text ourselves, as it could be nested in
    // other HTML elements etc.
    const value = trimNewlines(sanitizeSpaces(concatText(node)));

    // Empty expression are not valid inline expressions
    if (!value?.trim()) {
        return [];
    }

    return [expression.createExpression(value)];
}

function isInlineExpression(node: hast.Element): boolean {
    const classNames = getClassNamesAttribute(node.properties);

    if (classNames.includes('expression')) {
        return true;
    }

    return false;
}
